import { SuccessDialogComponent } from './../success-dialog/success-dialog.component';
import { catchError } from 'rxjs/internal/operators';
import { ErrorDialogComponent } from './../error-dialog/error-dialog.component';
import { MatDialog } from '@angular/material';
import { DataService } from './../services/data.service';
import { RespCenter } from './../models/resp-center.model';
import { AssetLocation } from './../models/asset-location.model';
import { ContractAdmin } from './../models/contract-admin.model';
import { MajorLocation } from './../models/major-location.model';
import { WorkOrderType } from './../models/work-order-type.model';
import { StateOption } from './../models/state-option.model';
import { Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { Activity } from '../models/activity.model';
import { of } from 'rxjs';
import { OperatingUnit } from '../models/operating-unit.model';
import { ConfigService } from '../services/config.service';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss']
})
export class SummaryComponent implements OnInit {
  webMethodUserName = this.config.getConfig('WebMethodUserName');
  webMethodPass = this.config.getConfig('WebMethodPassword');
  state: StateOption;
  businessUnit: string;
  fundingProjectID: string;
  projectName: string;
  operatingUnit: OperatingUnit;
  projectManager: string;
  projectLongDescription: string;
  problemStatement: string;
  proposedObjective: string;
  notes: string;
  activities: Activity[];
  assetLocation: AssetLocation;
  contractAdmin: ContractAdmin;
  estimatedCompletionDate: Date;
  estimatedInServiceDate: Date;
  estimatedStartDate: Date;
  majorLocation: MajorLocation;
  powerPlanProjectType: WorkOrderType;
  projectChargeIndicator: string;
  respCenter: RespCenter;
  costEstimate: number;

  editSummaryOn: boolean;

  projectNameCopy: string;
  powerPlanProjectTypeCopy: WorkOrderType;
  estimatedStartDateCopy: Date;
  estimatedInServiceDateCopy: Date;
  estimatedCompletionDateCopy: Date;
  majorLocationCopy: MajorLocation;
  projectChargeIndicatorCopy: string;
  respCenterCopy: RespCenter;
  contractAdminCopy: ContractAdmin;
  assetLocationCopy: AssetLocation;
  notesCopy: string;
  stateOptions: StateOption[];
  businessUnitOptions: string[];
  firstActivity: Activity;
  standardActivities: string[];
  lateWaitPeriod: number;
  firstStandardActivity: string;
  projectInitiatorEID: string;
  projectManagerEID: string;
  contractAdminEID: string;
  chargingProjectID: string;
  projectInitiatorLAN: string;
  projectManagerLAN: string;
  contractAdminLAN: string;
  parser: DOMParser;
  xmlDoc: any;
  submittingProject: boolean;

  constructor(private config: ConfigService,
    private router: Router, private dataService: DataService, private dialog: MatDialog) { }

  ngOnInit() {
    this.submittingProject = false;
    this.parser = new DOMParser();
    this.editSummaryOn = false;
    this.getProjectData();
  }

  getProjectData() {
    this.state = JSON.parse(sessionStorage.getItem('state'));
    this.businessUnit = sessionStorage.getItem('businessUnit');
    this.fundingProjectID = sessionStorage.getItem('fundingProjectID');
    this.projectName = sessionStorage.getItem('chargingProjectName');
    let operatingUnitCheck = sessionStorage.getItem('operatingUnit');
    if (operatingUnitCheck) {
      this.operatingUnit = JSON.parse(operatingUnitCheck);
    }
    else {
      this.operatingUnit = null;
    }
    this.projectManager = sessionStorage.getItem('projectManager');
    this.projectLongDescription = sessionStorage.getItem('chargingProjectLongDescription');
    this.problemStatement = sessionStorage.getItem('problemStatement');
    this.proposedObjective = sessionStorage.getItem('proposedObjective');
    this.notes = sessionStorage.getItem('notes');
    this.notes = this.notes.replace(/[^\x00-\x7F\xB0\u2019\u201D]/g, " ");
    let costEstimateCheck = sessionStorage.getItem('costEstimate');
    if (costEstimateCheck) {
      this.costEstimate = Number(costEstimateCheck);
    }
    else {
      this.costEstimate = null;
    }
    let activitiesCheck = sessionStorage.getItem('activities');
    if (activitiesCheck) {
      this.activities = JSON.parse(activitiesCheck);
      if (this.activities.length > 0) {
        this.firstActivity = this.activities[0];
        this.activities.splice(0, 1);
      }
    }
    else {
      this.activities = [];
    }
    let assetLocationCheck = sessionStorage.getItem('assetLocation');
    if (assetLocationCheck) {
      this.assetLocation = JSON.parse(assetLocationCheck);
    }
    else {
      this.assetLocation = null;
    }
    let contractAdminCheck = sessionStorage.getItem('contractAdmin');
    if (contractAdminCheck) {
      this.contractAdmin = JSON.parse(contractAdminCheck);
    }
    else {
      this.contractAdmin = null;
    }
    let startDateCheck = sessionStorage.getItem('estimatedStartDate');
    if (startDateCheck) {
      this.estimatedStartDate = new Date(startDateCheck);
      this.estimatedStartDate.setDate(this.estimatedStartDate.getDate() + 1);
    }
    else {
      this.estimatedStartDate = null;
    }
    let inServiceDateCheck = sessionStorage.getItem('estimatedInServiceDate');
    if (inServiceDateCheck) {
      this.estimatedInServiceDate = new Date(inServiceDateCheck);
      this.estimatedInServiceDate.setDate(this.estimatedInServiceDate.getDate() + 1);
    }
    else {
      this.estimatedInServiceDate = null;
    }
    let dateCopy = new Date(this.estimatedInServiceDate.getTime());
    this.lateWaitPeriod = parseInt(sessionStorage.getItem('lateWaitPeriod'));
    let originalDate = dateCopy.getDate();
    let completeDate;
    if (this.lateWaitPeriod == 0 || !this.lateWaitPeriod) {
      completeDate = new Date(dateCopy.setMonth(dateCopy.getMonth() + 3));
    }
    else {
      completeDate = new Date(dateCopy.setMonth(dateCopy.getMonth() + this.lateWaitPeriod));
    }
    let dateOffset = (24 * 60 * 60 * 1000);
    if ((originalDate === 31 || originalDate === 30) && completeDate.getDate() === 1) {
      while (completeDate.getDate() < 28) {
        completeDate.setTime(completeDate.getTime() - dateOffset);
      }
    }
    this.estimatedCompletionDate = completeDate;
    let majorLocationCheck = sessionStorage.getItem('majorLocation');
    if (majorLocationCheck) {
      this.majorLocation = JSON.parse(majorLocationCheck);
    }
    else {
      this.majorLocation = null;
    }
    let powerPlanProjectTypeCheck = sessionStorage.getItem('powerPlanProjectType');
    if (powerPlanProjectTypeCheck) {
      this.powerPlanProjectType = JSON.parse(powerPlanProjectTypeCheck);
    }
    else {
      this.powerPlanProjectType = null;
    }
    this.projectChargeIndicator = sessionStorage.getItem('projectChargeIndicator');
    let respCenterCheck = sessionStorage.getItem('respCenter');
    if (respCenterCheck) {
      this.respCenter = JSON.parse(respCenterCheck);
    }
    else {
      this.respCenter = null;
    }
    let stateOptionsCheck = sessionStorage.getItem('stateOptions');
    if (stateOptionsCheck) {
      this.stateOptions = JSON.parse(stateOptionsCheck);
    }
    else {
      this.stateOptions = [];
    }
    let businessUnitOptionsCheck = sessionStorage.getItem('businessUnitOptions');
    if (businessUnitOptionsCheck) {
      this.businessUnitOptions = JSON.parse(businessUnitOptionsCheck);
    }
    else {
      this.businessUnitOptions = [];
    }
    let standardActivityCheck = sessionStorage.getItem('standardActivities');
    if (standardActivityCheck) {
      this.standardActivities = JSON.parse(standardActivityCheck);
      if (this.standardActivities.length > 0) {
        this.firstStandardActivity = this.standardActivities[0];
        this.standardActivities.splice(0, 1);
      }
    }
    else {
      this.standardActivities = [];
    }
  }

  goToPreviousPage() {
    if (sessionStorage.getItem('activitySelect') === 'yes') {
      this.router.navigate(['/activity-selection']);
    }
    else {
      this.router.navigate(['/charging-project-setup']);
    }
  }

  editSummary() {
    this.editSummaryOn = true;
    this.saveCopiesOfSummary();
  }

  saveSummaryChanges() {
    this.editSummaryOn = false;
  }

  cancelSummaryChanges() {
    this.editSummaryOn = false;
    this.restoreCopiesOfSummary();
  }

  saveCopiesOfSummary() {
    this.projectNameCopy = this.projectName;
    this.powerPlanProjectTypeCopy = this.powerPlanProjectType;
    this.estimatedStartDateCopy = new Date(this.estimatedStartDate.getTime());
    this.estimatedInServiceDateCopy = new Date(this.estimatedInServiceDate.getTime());
    this.estimatedCompletionDateCopy = new Date(this.estimatedCompletionDate.getTime());
    this.majorLocationCopy = this.majorLocation;
    this.projectChargeIndicatorCopy = this.projectChargeIndicator;
    this.respCenterCopy = this.respCenter;
    this.contractAdminCopy = this.contractAdmin;
    this.assetLocationCopy = this.assetLocation;
    this.notesCopy = this.notes;
  }

  restoreCopiesOfSummary() {
    this.projectName = this.projectNameCopy;
    this.powerPlanProjectType = this.powerPlanProjectTypeCopy;
    this.estimatedStartDate = this.estimatedStartDateCopy;
    this.estimatedInServiceDate = this.estimatedInServiceDateCopy;
    this.estimatedCompletionDate = this.estimatedCompletionDateCopy;
    this.majorLocation = this.majorLocationCopy;
    this.projectChargeIndicator = this.projectChargeIndicatorCopy;
    this.respCenter = this.respCenterCopy;
    this.contractAdmin = this.contractAdminCopy;
    this.assetLocation = this.assetLocationCopy;
    this.notes = this.notesCopy;
  }

  compareState(o1: any, o2: any): boolean {
    if (!o1 || !o2) {
      return false;
    }
    return o1.state == o2.state && o1.major_loc_id == o2.major_loc_id && o1.majorlocation == o2.majorlocation;
  }

  getChargingProjectID(callBody: any) {
    return this.dataService.getGeneratedChargingProjectID(callBody);
  }

  convertToEmployeeID(lanID: string) {
    return this.dataService.convertToEmployeeIDTEST(lanID).pipe(
      catchError((error) => {
        console.log('error', error);
        let errorType = '';
        let errorDescription = '';
        if (error.error.message) {
          errorDescription = errorDescription.concat('Employee ID Convert Error - ', error.error.message);
        }
        else {
          errorDescription = errorDescription.concat('Employee ID Convert Error');
        }
        errorType = errorType.concat(error.status, ' ', error.statusText)
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true
        });
        return of(error);
      })
    );
  }

  goToEstimates() {
    this.router.navigate(['/estimate']);
  }

  submitChargingProject() {
    this.submittingProject = true;
    this.projectInitiatorLAN = JSON.parse(sessionStorage.getItem('fullTokenPayload')).username;
    this.projectManagerLAN = sessionStorage.getItem('projectManagerID');
    this.contractAdminLAN = this.contractAdmin.users;
    // Graph API Calls Removed
    /*let convertCalls = [this.convertToEmployeeID(this.projectInitiatorLAN), this.convertToEmployeeID(this.projectManagerLAN),
      this.convertToEmployeeID(this.contractAdminLAN)];
    forkJoin(convertCalls).subscribe((results) => {
      let errorFound = false;
      for (let i = 0; i < 3; i++) {
        if (results[i].value.length > 0) {
          if (i == 0) {
            this.projectInitiatorEID = results[i].value[0].employeeId;
          }
          else if (i == 1) {
            this.projectManagerEID = results[i].value[0].employeeId;
          }
          else {
            this.contractAdminEID = results[i].value[0].employeeId;
          }
        }
        else {
          errorFound = true;
          let errorType = '';
          let errorDescription = '';
          errorDescription = errorDescription.concat('Employee ID Convert Error - No Results Found for ');
          if (i == 0) {
            errorDescription = errorDescription.concat('Project Initiator');
          }  
          else if (i == 1) {
            errorDescription = errorDescription.concat('Project Manager');
          }
          else {
            errorDescription = errorDescription.concat('Contract Admin');
          }
          errorType = errorType.concat('No Results Found');
          let dataStructure = {
            errorType: errorType,
            errorDescription: errorDescription
          };
          this.dialog.open(ErrorDialogComponent, {
            data: dataStructure,
            disableClose: true
          });
        }
      }
      if (!errorFound) {*/
    let standardActivityList = [];
    if (this.firstStandardActivity) {
      standardActivityList.push(this.firstStandardActivity);
    }
    else {
      standardActivityList.push('');
    }
    for (let i = 0; i < this.standardActivities.length; i++) {
      standardActivityList.push(this.standardActivities[i]);
    }
    let nonStandardActivityList = [];
    if (this.firstActivity) {
      nonStandardActivityList.push(this.firstActivity.activityID);
    }
    else {
      nonStandardActivityList.push('');
    }
    for (let i = 0; i < this.activities.length; i++) {
      nonStandardActivityList.push(this.activities[i].activityID);
    }
    let callBody = {
      businessUnit: this.businessUnit,
      fundProjId: this.fundingProjectID,
      state: this.state.state,
      projectInitiator: this.projectInitiatorLAN,
      projectName: this.projectName,
      pplnProjectType: this.powerPlanProjectType.description,
      costEstimate: this.costEstimate.toString(),
      prjLongDesc: this.projectLongDescription,
      estStartDate: ((this.estimatedStartDate.getMonth() > 8) ? (this.estimatedStartDate.getMonth() + 1) : ('0' + (this.estimatedStartDate.getMonth() + 1)))
        + '/' + ((this.estimatedStartDate.getDate() > 9) ? this.estimatedStartDate.getDate() : ('0' + this.estimatedStartDate.getDate()))
        + '/' + this.estimatedStartDate.getFullYear(),
      estCompletionDate: ((this.estimatedCompletionDate.getMonth() > 8) ? (this.estimatedCompletionDate.getMonth() + 1) : ('0' + (this.estimatedCompletionDate.getMonth() + 1)))
        + '/' + ((this.estimatedCompletionDate.getDate() > 9) ? this.estimatedCompletionDate.getDate() : ('0' + this.estimatedCompletionDate.getDate()))
        + '/' + this.estimatedCompletionDate.getFullYear(),
      estInServiceDate: ((this.estimatedInServiceDate.getMonth() > 8) ? (this.estimatedInServiceDate.getMonth() + 1) : ('0' + (this.estimatedInServiceDate.getMonth() + 1)))
        + '/' + ((this.estimatedInServiceDate.getDate() > 9) ? this.estimatedInServiceDate.getDate() : ('0' + this.estimatedInServiceDate.getDate()))
        + '/' + this.estimatedInServiceDate.getFullYear(),
      majorLocation: this.majorLocation.major_location,
      standardActivities: standardActivityList,
      nonStandardActivities: nonStandardActivityList,
      projectManager: this.projectManager,
      contractAdmin: this.contractAdmin.full_name,
      problemStatement: this.problemStatement,
      notes: this.notes,
      proposedObjective: this.proposedObjective,
      projectChargeIndicator: this.projectChargeIndicator,
      assetLocation: this.assetLocation.long_description,
      respCenter: this.respCenter.DEPARTMENT_ID,
      operatingUnit: this.operatingUnit.OPERATING_UNIT
    };
    this.getChargingProjectID(callBody).subscribe((result) => {
      if (result && result.body && result.body.charging_project_id) {
        this.chargingProjectID = result.body.charging_project_id;
        this.submitProjectSOAP();
      }
      else {
        console.log('error - no Charging Project ID returned');
        let errorType = '';
        let errorDescription = '';
        errorDescription = errorDescription.concat('Get Charging Project ID Error - no ID returned');
        errorType = errorType.concat('No Charging Project ID Returned')
        let dataStructure = {
          errorType: errorType,
          errorDescription: errorDescription
        };
        this.dialog.open(ErrorDialogComponent, {
          data: dataStructure,
          disableClose: true
        });
        this.submittingProject = false;
      }
    }, error => {
      console.log('error', error);
      let errorType = '';
      let errorDescription = '';
      if (error.error.message) {
        errorDescription = errorDescription.concat('Get Charging Project ID Error - ', error.error.message);
      }
      else {
        errorDescription = errorDescription.concat('Get Charging Project ID Error');
      }
      errorType = errorType.concat(error.status, ' ', error.statusText)
      let dataStructure = {
        errorType: errorType,
        errorDescription: errorDescription
      };
      this.dialog.open(ErrorDialogComponent, {
        data: dataStructure,
        disableClose: true
      });
      this.submittingProject = false;
    });
  }
  // Graph API calls removed.
  //});
  //}

  submitProjectSOAP() {
    let doc = document.implementation.createDocument("", "", null);
    const pi = doc.createProcessingInstruction('xml', 'version="1.0" encoding="UTF-8"');
    doc.insertBefore(pi, doc.firstChild);
    let elem1 = doc.createElement("soapenv:Envelope");
    elem1.setAttribute("xmlns:soapenv", "http://schemas.xmlsoap.org/soap/envelope/");
    let elem2 = doc.createElement("soapenv:Header");
    let elem3 = doc.createElement("wsse:Security");
    elem3.setAttribute("soapenv:mustUnderstand", "111");
    elem3.setAttribute("xmlns:wsse", "http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-wssecurity-secext-1.0.xsd");
    elem3.setAttribute("xmlns:wsu", "http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-wssecurity-utility-1.0.xsd");
    let elem4 = doc.createElement("wsse:UsernameToken");
    elem4.setAttribute("wsu:Id", "UsernameToken-459");
    let elem5 = doc.createElement("wsse:Username");
    // this needs to be parameterized.
    elem5.innerHTML = this.encodeToXML(this.webMethodUserName);
    let elem6 = doc.createElement("wsse:Password");
    elem6.setAttribute("Type", "http://docs.oasis-open.org/wss/2004/01/oasis-200401-wss-username-token-profile-1.0#PasswordText");
    // this needs to be parameterized.
    elem6.innerHTML = this.encodeToXML(this.webMethodPass);
    elem4.appendChild(elem5);
    elem4.appendChild(elem6);
    elem3.appendChild(elem4);
    elem2.appendChild(elem3);
    let elem7 = doc.createElement("soapenv:Body");
    let elem8 = doc.createElement("ns4:createAndChange_Project");
    elem8.setAttribute("xmlns:ns2", "urn:duk:objects:xmlschema:FIN:Project:version1.0.02Out");
    elem8.setAttribute("xmlns:ns3", "urn:duk:objects:xmlschema:FIN:Project:version1.0.02");
    elem8.setAttribute("xmlns:ns4", "urn:duk:objects:xmlschema:FIN:Project:version1.0.02In");
    elem8.setAttribute("xmlns:ns5", "urn:duk:objects:xmlschema:INF:FaultReturn:version1.02");
    let elem9 = doc.createElement("MessageHeader");
    let elem10 = doc.createElement("identifier");
    elem10.innerHTML = this.encodeToXML("MMAPS_PPFC6EC80FCD9FCA1D.0");
    let elem11 = doc.createElement("referenceID");
    elem11.innerHTML = this.encodeToXML("PLUSDESTVERSION_PLUSDESTVERSION :  Estimate Request=5581201 Estimate Version=4 Organization=DUKE");
    let elem12 = doc.createElement("source");
    elem12.innerHTML = "MMAPS";
    let elem13 = doc.createElement("target");
    elem13.innerHTML = "POWERPLAN";
    elem9.appendChild(elem10);
    elem9.appendChild(elem11);
    elem9.appendChild(elem12);
    elem9.appendChild(elem13);
    let elem14 = doc.createElement("Project");
    let elem15 = doc.createElement("description");
    // Project Name
    elem15.innerHTML = this.encodeToXML(this.projectName);
    let elem16 = doc.createElement("type");
    // PowerPlan Project Type
    elem16.innerHTML = this.encodeToXML(this.powerPlanProjectType.description);
    let elem17 = doc.createElement("localID");
    // Charging Project ID
    elem17.innerHTML = this.chargingProjectID;
    let elem18 = doc.createElement("costEstimate");
    let elem19 = doc.createElement("currencyUnit");
    elem19.innerHTML = "USD";
    let elem20 = doc.createElement("decimalValue");
    // Cost Estimate
    elem20.innerHTML = this.costEstimate.toString();
    elem18.appendChild(elem19);
    elem18.appendChild(elem20);
    let elem21 = doc.createElement("extendedDescription");
    // Project Long Description
    elem21.innerHTML = this.encodeToXML(this.projectLongDescription);
    let elem22 = doc.createElement("fundingProject");
    // Funding Project ID
    elem22.innerHTML = this.encodeToXML(this.fundingProjectID);
    let elem23 = doc.createElement("Dates");
    let elem24 = doc.createElement("date");
    let correctedDate = new Date();
    let dateOffset = (24 * 60 * 60 * 1000);
    // Estimated Start Date
    correctedDate.setTime(this.estimatedStartDate.getTime() - dateOffset);
    elem24.innerHTML = correctedDate.toISOString().slice(0, 10);
    let elem25 = doc.createElement("category");
    elem25.innerHTML = "EstimatedStartDate";
    elem23.appendChild(elem24);
    elem23.appendChild(elem25);
    let elem26 = doc.createElement("Dates");
    let elem27 = doc.createElement("date");
    // Estimated Completion Date
    correctedDate.setTime(this.estimatedCompletionDate.getTime() - dateOffset);
    elem27.innerHTML = correctedDate.toISOString().slice(0, 10);
    let elem28 = doc.createElement("category");
    elem28.innerHTML = "EstimatedCompletionDate";
    elem26.appendChild(elem27);
    elem26.appendChild(elem28);
    let elem29 = doc.createElement("Dates");
    let elem30 = doc.createElement("date");
    // Estimated In Service Date
    correctedDate.setTime(this.estimatedInServiceDate.getTime() - dateOffset);
    elem30.innerHTML = correctedDate.toISOString().slice(0, 10);
    let elem31 = doc.createElement("category");
    elem31.innerHTML = "EstimatedInServiceDate";
    elem29.appendChild(elem30);
    elem29.appendChild(elem31);
    let elem32 = doc.createElement("Location");
    let elem33 = doc.createElement("localID");
    // Major Location (ID)
    elem33.innerHTML = this.encodeToXML(this.majorLocation.major_loc_id);
    elem32.appendChild(elem33);
    let activityElems = [];
    if (this.firstStandardActivity) {
      let actElem1 = doc.createElement("WorkTasks");
      let actElem2 = doc.createElement("localID");
      // Activity ID
      actElem2.innerHTML = this.firstStandardActivity;
      let actElem3 = doc.createElement("description");
      // Activity Description
      actElem3.innerHTML = this.firstStandardActivity;
      let actElem4 = doc.createElement("extendedDescription");
      // Activity Process (slot 1 of 2)
      actElem4.innerHTML = this.firstStandardActivity;
      let actElem5 = doc.createElement("ErpProjectAccounting");
      let actElem6 = doc.createElement("CodeBlock");
      let actElem7 = doc.createElement("businessUnit");
      let actElem8 = doc.createElement("process")
      // Activity Process (slot 2 of 2)
      actElem8.innerHTML = ' ';
      actElem6.appendChild(actElem7);
      actElem6.appendChild(actElem8);
      actElem5.appendChild(actElem6);
      actElem1.appendChild(actElem2);
      actElem1.appendChild(actElem3);
      actElem1.appendChild(actElem4);
      actElem1.appendChild(actElem5);
      activityElems.push(actElem1);
    }
    if (this.standardActivities) {
      for (let i = 0; i < this.standardActivities.length; i++) {
        let actElem1 = doc.createElement("WorkTasks");
        let actElem2 = doc.createElement("localID");
        // Activity ID
        actElem2.innerHTML = this.standardActivities[i];
        let actElem3 = doc.createElement("description");
        // Activity Description
        actElem3.innerHTML = this.standardActivities[i];
        let actElem4 = doc.createElement("extendedDescription");
        // Activity Process (slot 1 of 2)
        actElem4.innerHTML = this.standardActivities[i];
        let actElem5 = doc.createElement("ErpProjectAccounting");
        let actElem6 = doc.createElement("CodeBlock");
        let actElem7 = doc.createElement("businessUnit");
        let actElem8 = doc.createElement("process")
        // Activity Process (slot 2 of 2)
        actElem8.innerHTML = ' ';
        actElem6.appendChild(actElem7);
        actElem6.appendChild(actElem8);
        actElem5.appendChild(actElem6);
        actElem1.appendChild(actElem2);
        actElem1.appendChild(actElem3);
        actElem1.appendChild(actElem4);
        actElem1.appendChild(actElem5);
        activityElems.push(actElem1);
      }
    }
    if (this.firstActivity) {
      let actElem1 = doc.createElement("WorkTasks");
      let actElem2 = doc.createElement("localID");
      // Activity ID
      actElem2.innerHTML = this.encodeToXML(this.firstActivity.activityID);
      let actElem3 = doc.createElement("description");
      // Activity Description
      actElem3.innerHTML = this.encodeToXML(this.firstActivity.description);
      let actElem4 = doc.createElement("extendedDescription");
      // Activity Process (slot 1 of 2)
      actElem4.innerHTML = this.encodeToXML(this.firstActivity.process);
      let actElem5 = doc.createElement("ErpProjectAccounting");
      let actElem6 = doc.createElement("CodeBlock");
      let actElem7 = doc.createElement("businessUnit");
      let actElem8 = doc.createElement("process")
      // Activity Process (slot 2 of 2)
      actElem8.innerHTML = this.encodeToXML(this.firstActivity.process);
      actElem6.appendChild(actElem7);
      actElem6.appendChild(actElem8);
      actElem5.appendChild(actElem6);
      actElem1.appendChild(actElem2);
      actElem1.appendChild(actElem3);
      actElem1.appendChild(actElem4);
      actElem1.appendChild(actElem5);
      activityElems.push(actElem1);
    }
    if (this.activities) {
      for (let i = 0; i < this.activities.length; i++) {
        let actElem1 = doc.createElement("WorkTasks");
        let actElem2 = doc.createElement("localID");
        // Activity ID
        actElem2.innerHTML = this.encodeToXML(this.activities[i].activityID);
        let actElem3 = doc.createElement("description");
        // Activity Description
        actElem3.innerHTML = this.encodeToXML(this.activities[i].description);
        let actElem4 = doc.createElement("extendedDescription");
        // Activity Process (slot 1 of 2)
        actElem4.innerHTML = this.encodeToXML(this.activities[i].process);
        let actElem5 = doc.createElement("ErpProjectAccounting");
        let actElem6 = doc.createElement("CodeBlock");
        let actElem7 = doc.createElement("businessUnit");
        let actElem8 = doc.createElement("process")
        // Activity Process (slot 2 of 2)
        actElem8.innerHTML = this.encodeToXML(this.activities[i].process);
        actElem6.appendChild(actElem7);
        actElem6.appendChild(actElem8);
        actElem5.appendChild(actElem6);
        actElem1.appendChild(actElem2);
        actElem1.appendChild(actElem3);
        actElem1.appendChild(actElem4);
        actElem1.appendChild(actElem5);
        activityElems.push(actElem1);
      }
    }
    // Non-Graph API approach.
    let elem34 = doc.createElement("Persons");
    let elem35 = doc.createElement("Credentials");
    let elem36 = doc.createElement("userID");
    elem36.innerHTML = this.encodeToXML(this.projectManagerLAN);
    elem35.appendChild(elem36);
    let elem37 = doc.createElement("PersonRole");
    let elem38 = doc.createElement("name");
    elem38.innerHTML = "ProjectManager";
    elem37.appendChild(elem38);
    elem34.appendChild(elem35);
    elem34.appendChild(elem37);
    let elem39 = doc.createElement("Persons");
    let elem40 = doc.createElement("Credentials");
    let elem41 = doc.createElement("userID");
    elem41.innerHTML = this.encodeToXML(this.contractAdminLAN);
    elem40.appendChild(elem41);
    let elem42 = doc.createElement("PersonRole");
    let elem43 = doc.createElement("name");
    elem43.innerHTML = "ContractAdministrator";
    elem42.appendChild(elem43);
    elem39.appendChild(elem40);
    elem39.appendChild(elem42);
    let elem44 = doc.createElement("Persons");
    let elem45 = doc.createElement("Credentials");
    let elem45a = doc.createElement("userID");
    elem45a.innerHTML = this.encodeToXML(this.projectInitiatorLAN);
    //For Testing
    //elem45a.innerHTML = 'T18553';
    elem45.appendChild(elem45a);
    let elem45b = doc.createElement("PersonRole");
    let elem45c = doc.createElement("name");
    elem45c.innerHTML = "ProjectInitiator";
    elem45b.appendChild(elem45c);
    elem44.appendChild(elem45);
    elem44.appendChild(elem45b);
    // Graph API Calls Removed
    /*let elem34 = doc.createElement("Persons");
    let elem35 = doc.createElement("localID");
    // Project Manager (Employee ID)
    elem35.innerHTML = this.projectManagerEID;
    let elem36 = doc.createElement("PersonRole");
    let elem37 = doc.createElement("name");
    elem37.innerHTML = "ProjectManager";
    elem36.appendChild(elem37);
    elem34.appendChild(elem35);
    elem34.appendChild(elem36);
    let elem38 = doc.createElement("Persons");
    let elem39 = doc.createElement("localID");
    // Contract Admin (Employee ID)
    elem39.innerHTML = this.contractAdminEID;
    let elem40 = doc.createElement("PersonRole");
    let elem41 = doc.createElement("name");
    elem41.innerHTML = "ContractAdministrator";
    elem40.appendChild(elem41);
    elem38.appendChild(elem39);
    elem38.appendChild(elem40);
    let elem42 = doc.createElement("Persons");
    let elem43 = doc.createElement("localID");
    // Project Initiator (Employee ID)
    elem43.innerHTML = this.projectInitiatorEID;
    let elem44 = doc.createElement("PersonRole");
    let elem45 = doc.createElement("name");
    elem45.innerHTML = "ProjectInitiator";
    elem44.appendChild(elem45);
    elem42.appendChild(elem43);
    elem42.appendChild(elem44);*/
    let elem46 = doc.createElement("remarks");
    // Problem Statement
    elem46.innerHTML = this.encodeToXML(this.problemStatement);
    let elem47 = doc.createElement("comment");
    // Notes
    elem47.innerHTML = this.encodeToXML(this.notes);
    let elem48 = doc.createElement("reason");
    // Proposed Objective
    elem48.innerHTML = this.encodeToXML(this.proposedObjective);
    let elem49 = doc.createElement("Codes");
    let elem50 = doc.createElement("code");
    // Project Charge Indicator
    elem50.innerHTML = this.encodeToXML(this.projectChargeIndicator);
    let elem51 = doc.createElement("category");
    elem51.innerHTML = "ProjectChargeCode";
    elem49.appendChild(elem50);
    elem49.appendChild(elem51);
    let elem52 = doc.createElement("Assets");
    let elem53 = doc.createElement("isReplacement");
    elem53.innerHTML = "false";
    let elem54 = doc.createElement("Location");
    let elem55 = doc.createElement("localID");
    // Asset Location (ID)
    elem55.innerHTML = this.encodeToXML(this.assetLocation.ext_asset_location);
    elem54.appendChild(elem55);
    elem52.appendChild(elem53);
    elem52.appendChild(elem54);
    let elem56 = doc.createElement("ErpProjectAccounting");
    let elem57 = doc.createElement("CodeBlock");
    let elem58 = doc.createElement("businessUnit");
    // Business Unit
    elem58.innerHTML = this.encodeToXML(this.businessUnit);
    let elem59 = doc.createElement("responsibilityCenter");
    // Resp Center
    elem59.innerHTML = this.encodeToXML(this.respCenter.DEPARTMENT_ID);
    let elem60 = doc.createElement("operatingUnit");
    // Operating Unit
    elem60.innerHTML = this.encodeToXML(this.operatingUnit.OPERATING_UNIT);
    let elem61 = doc.createElement("process");
    elem61.innerHTML = " ";
    elem57.appendChild(elem58);
    elem57.appendChild(elem59);
    elem57.appendChild(elem60);
    elem57.appendChild(elem61);
    elem56.appendChild(elem57);
    let elem62 = doc.createElement("Transaction");
    let elem63 = doc.createElement("type");
    elem63.innerHTML = "LOAD_PROJECT_HEADER";
    elem62.appendChild(elem63);
    elem14.appendChild(elem15);
    elem14.appendChild(elem16);
    elem14.appendChild(elem17);
    elem14.appendChild(elem18);
    elem14.appendChild(elem21);
    elem14.appendChild(elem22);
    elem14.appendChild(elem23);
    elem14.appendChild(elem26);
    elem14.appendChild(elem29);
    elem14.appendChild(elem32);
    for (let i = 0; i < activityElems.length; i++) {
      elem14.appendChild(activityElems[i]);
    }
    elem14.appendChild(elem34);
    elem14.appendChild(elem39);
    elem14.appendChild(elem44);
    // Graph API calls removed.
    /*elem14.appendChild(elem34);
    elem14.appendChild(elem38);
    elem14.appendChild(elem42);*/
    elem14.appendChild(elem46);
    elem14.appendChild(elem47);
    elem14.appendChild(elem48);
    elem14.appendChild(elem49);
    elem14.appendChild(elem52);
    elem14.appendChild(elem56);
    elem14.appendChild(elem62);
    elem8.appendChild(elem9);
    elem8.appendChild(elem14);
    elem7.appendChild(elem8);
    elem1.appendChild(elem2);
    elem1.appendChild(elem7);
    doc.appendChild(elem1);
    let finalString = '<?xml version="1.0" encoding="UTF-8"?>'.concat(doc.documentElement.outerHTML);
    this.dataService.submitProjectTEST(finalString).subscribe((result) => {
      this.xmlDoc = this.parser.parseFromString(result, "text/xml");
      if (this.xmlDoc.getElementsByTagName("Transaction")[0].childNodes[1].innerHTML === 'ERROR') {
        let dataStructure;
        let errors = this.xmlDoc.getElementsByTagName("errorMessage");
        let errorTexts = [];
        for (let i = 0; i < errors.length; i++) {
          errorTexts.push(errors[i].innerHTML);
        }
        dataStructure = {
          error: true,
          data: errorTexts
        }
        this.dialog.open(SuccessDialogComponent, {
          disableClose: true,
          data: dataStructure
        });
      }
      else {
        let dataStructure = {
          error: false,
          data: this.chargingProjectID
        }
        sessionStorage.setItem('chargingProjectID', this.chargingProjectID);
        this.dialog.open(SuccessDialogComponent, {
          disableClose: true,
          data: dataStructure
        });
      }
      this.submittingProject = false;
    }, error => {
      console.log('error', error);
      let errorType = '';
      let errorDescription = '';
      if (error.error.message) {
        errorDescription = errorDescription.concat('Submit Project Error - ', error.error.message);
      }
      else {
        errorDescription = errorDescription.concat('Submit Project Error');
      }
      errorType = errorType.concat(error.status, ' ', error.statusText)
      let dataStructure = {
        errorType: errorType,
        errorDescription: errorDescription
      };
      this.dialog.open(ErrorDialogComponent, {
        data: dataStructure,
        disableClose: true
      });
      this.submittingProject = false;
    });
  }

  encodeToXML(encodeString: string) {
    if (encodeString) {
      return encodeString.replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&apos;');
    }
    else {
      return '';
    }
  }

  exitPage() {
    this.router.navigate(['/dashboard']);
  }

}
